import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import styled from '@emotion/styled';
import { computed } from 'mobx';
import SettingsMenuRow from './settings_menu_row';
import SeedlangOnly from 'utils/seedlang_only';
import WhitelabelOnly from 'utils/whitelabel_only';

const MenuContainer = styled.div`
  grid-area: menu;
  width: ${props => props.width};
  margin: ${props => props.margin};
  border-radius: ${props => props.borderRadius};
  overflow: hidden;
`;

@observer
class SettingsMenu extends React.Component {
  @computed get navigationItems() {
    return AppUI.site.navigationItems
      .filter(item => item.showInUserSettings && item.path.startsWith('/pages/'))
      .map(item => {
        const match = item.path.match(/\/pages\/(.*)/);
        return { name: item.name, id: item.id, pageId: match ? match[1] : null };
      });
  }

  render() {
    return (
      <MenuContainer
        width={AppUI.layout.isMobile ? '100%' : '250px'}
        borderRadius={AppUI.layout.isMobile ? 0 : '10px'}
      >
        <SettingsMenuRow
          to='settings.user_profile'
          selected={this.props.children?.props?.route?.name === 'settings.user_profile'}
        >
          User Settings
        </SettingsMenuRow>
        <SeedlangOnly>
          <SettingsMenuRow
            to='settings.user_image'
            selected={this.props.children?.props?.route?.name === 'settings.user_image'}
          >
            Profile Image
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.password'
            selected={this.props.children?.props?.route?.name === 'settings.password'}
          >
            Change Password
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.deck'
            selected={this.props.children?.props?.route?.name === 'settings.deck'}
          >
            Deck Settings
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.clear_progress'
            selected={this.props.children?.props?.route?.name === 'settings.clear_progress'}
          >
            Clear Progress
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.streak_repair'
            selected={this.props.children?.props?.route?.name === 'settings.streak_repair'}
          >
            Streak Repair
          </SettingsMenuRow>
          <SettingsMenuRow
            to='settings.user_notifications'
            selected={this.props.children?.props?.route?.name === 'settings.user_notifications'}
          >
            Notifications
          </SettingsMenuRow>
        </SeedlangOnly>
        <SeedlangOnly>
          <SettingsMenuRow
            to='settings.patreon'
            selected={this.props.children?.props?.route?.name === 'settings.patreon'}
          >
            Patreon Account
          </SettingsMenuRow>
        </SeedlangOnly>
        <SettingsMenuRow
          to='settings.billing'
          selected={this.props.children?.props?.route?.name === 'settings.billing'}
        >
          {AppUI.siteIsDefault ? 'Manage Subscription' : 'Manage Membership'}
        </SettingsMenuRow>
        <WhitelabelOnly>
          <SettingsMenuRow
            to='settings.email'
            selected={this.props.children?.props?.route?.name === 'settings.email'}
          >
            Email Preferences
          </SettingsMenuRow>
        </WhitelabelOnly>
        <WhitelabelOnly>
          <SettingsMenuRow
            to='settings.audio_feeds'
            selected={this.props.children?.props?.route?.name === 'settings.audio_feeds'}
          >
            Audio Feeds
          </SettingsMenuRow>
        </WhitelabelOnly>
        {
          this.navigationItems.map(navigationItem => {
            return (
              <SettingsMenuRow
                key={navigationItem.id}
                to={{ name: 'settings.page.show', params: {pageId: navigationItem?.pageId} }}
                selected={this.props.children?.props?.route?.name === 'settings.page.show' && this.props.params?.pageId === navigationItem?.pageId}
              >
                {navigationItem.name}
              </SettingsMenuRow>
              );
          })
        }
        <SettingsMenuRow
          to='settings.privacy'
          selected={this.props.children?.props?.route?.name === 'settings.privacy'}
        >
          Privacy
        </SettingsMenuRow>
      </MenuContainer>
    );
  }
}

export default SettingsMenu;